import GlobalLeaderBoardsPage from '../../../components/GlobalLeaderBoardsPage/GlobalLeaderBoards';


const GlobalLeaderBoards = () => {
  return <GlobalLeaderBoardsPage />;
}

export default GlobalLeaderBoards;